import { Injectable } from '@angular/core';
import { AuthService } from '@shared/services/auth.service';
import { MessageHelperService } from '@shared/services/message-helper.service';
import { SnackbarService } from '@shared/services/snackbar.service';
import { BehaviorSubject } from 'rxjs';
import { delay, filter } from 'rxjs/operators';

export enum AppModes {
  PRODUCER = 'PRODUCER',
  DISTRIBUTOR = 'DISTRIBUTOR',
  CLIENT = 'CLIENT',
}

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private isLoading = new BehaviorSubject(false);
  pageSearchContent$ = new BehaviorSubject<string>(null);
  isLoading$ = this.isLoading.asObservable().pipe(delay(0)); // delay to avoid ng0100
  appMode$ = new BehaviorSubject<AppModes>(null);
  private currentLoader: { id: number };
  private lastLoaderId = 0;
  appUpdateRequired = false;

  constructor(
    private messageHelperService: MessageHelperService,
    private authService: AuthService,
    public snackbarService: SnackbarService,
  ) {
    this.appMode$.pipe(filter((v) => !!v)).subscribe({
      next: (data) => {
        // eslint-disable-next-line no-console
        console.info('APP MODE:', data);
      },
    });

    this.authService.authData$.subscribe({
      next: (data) => {
        if (data?.companyType) {
          this.appMode$.next(data.companyType);
        }
      },
    });
  }

  showAppUpdateNotification() {
    this.appUpdateRequired = true;
  }

  hideAppUpdateNotification() {
    this.appUpdateRequired = false;
  }

  /**
   * Deprecated in favor of busyInterceptor
   */
  startLoader(): () => void {
    this.currentLoader = { id: ++this.lastLoaderId };
    this.isLoading.next(true);
    return this.getStopLoaderFn(this.currentLoader);
  }

  stopAnyLoader() {
    this.isLoading.next(false);
    this.currentLoader = null;
  }

  /**
   * Для остановки лоадера используйте функцию, которую возвращает метод startLoader
   */
  private stopLoader() {
    this.isLoading.next(false);
  }

  private getStopLoaderFn(loader: { id: number }) {
    return () => this.stopLoaderFn(loader);
  }

  private stopLoaderFn(loader: { id: number }) {
    if (this.currentLoader === loader) {
      this.stopLoader();
      this.currentLoader = null;
    }
  }
}
